/* Pick-cards popup. One instance per section id. State persisted:
   - localStorage "up-pickcards:seen:<id>" / "up-pickcards:played:<id>":
     gates the auto-open so the popup does not nag on every page view.
   - sessionStorage "up-pickcards:order:<id>": the shuffled reward order,
     so a refresh mid-game keeps the same cards instead of reshuffling. */
(function () {
  function getFlag(key) {
    try {
      return window.localStorage.getItem(key) === '1';
    } catch (e) {
      return false;
    }
  }

  function setFlag(key) {
    try {
      window.localStorage.setItem(key, '1');
    } catch (e) {
      /* localStorage unavailable (private mode etc.): degrade to "always show". */
    }
  }

  function getOrder(sectionId, length) {
    var key = 'up-pickcards:order:' + sectionId;
    try {
      var stored = window.sessionStorage.getItem(key);
      if (stored) {
        var parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.length === length) return parsed;
      }
    } catch (e) {
      /* ignore, fall through to a fresh shuffle */
    }

    var order = [];
    for (var i = 0; i < length; i++) order.push(i);
    for (var j = order.length - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var tmp = order[j];
      order[j] = order[k];
      order[k] = tmp;
    }

    try {
      window.sessionStorage.setItem(key, JSON.stringify(order));
    } catch (e) {
      /* ignore */
    }

    return order;
  }

  function getFocusable(container) {
    var nodes = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(nodes, function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function initInstance(root) {
    if (root.hasAttribute('data-up-pickcards-ready')) return;
    root.setAttribute('data-up-pickcards-ready', 'true');

    if (root.hasAttribute('data-up-pickcards-disabled')) return;

    var configEl = root.querySelector('[data-up-pickcards-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    if (config.enabled === false) return;

    var rewards = (config.rewards || []).filter(function (reward) {
      return reward && reward.label;
    });
    if (!rewards.length) return;

    var sectionId = config.sectionId || root.id;
    var seenKey = 'up-pickcards:seen:' + sectionId;
    var playedKey = 'up-pickcards:played:' + sectionId;

    var pickCount = parseInt(config.pickCount, 10);
    if (!pickCount || pickCount < 1) pickCount = 4;
    pickCount = Math.min(pickCount, rewards.length);

    var delayMs = parseFloat(config.delaySeconds);
    if (isNaN(delayMs) || delayMs < 0) delayMs = 5;
    delayMs *= 1000;

    var dialog = root.querySelector('[data-up-pickcards-dialog]');
    var closeBtn = root.querySelector('[data-up-pickcards-close]');
    var grid = root.querySelector('[data-up-pickcards-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-up-pickcards-card]'));
    var resultsPanel = root.querySelector('[data-up-pickcards-results]');
    var resultsList = root.querySelector('[data-up-pickcards-results-list]');
    var ctaBtn = root.querySelector('[data-up-pickcards-cta]');

    if (!dialog || !cards.length) return;

    var order = getOrder(sectionId, rewards.length);

    cards.forEach(function (card, index) {
      if (index >= order.length) {
        card.hidden = true;
        return;
      }
      var reward = rewards[order[index]];
      card.upReward = reward;
      var labelEl = card.querySelector('[data-up-pickcards-reward-label]');
      var descEl = card.querySelector('[data-up-pickcards-reward-desc]');
      if (labelEl) labelEl.textContent = reward.label;
      if (descEl) descEl.textContent = reward.description || '';
    });

    var picked = [];
    var isDone = false;

    function pickCard(card) {
      if (isDone || card.disabled || card.classList.contains('is-flipped') || card.hidden) return;
      card.classList.add('is-flipped');
      card.setAttribute('aria-pressed', 'true');
      picked.push(card.upReward);
      if (picked.length >= pickCount) finish();
    }

    function finish() {
      isDone = true;
      setFlag(playedKey);
      cards.forEach(function (card) {
        if (!card.classList.contains('is-flipped')) {
          card.setAttribute('aria-disabled', 'true');
        }
        card.disabled = true;
        card.setAttribute('tabindex', '-1');
      });
      if (grid) grid.classList.add('is-done');
      renderResults();
    }

    function renderResults() {
      if (!resultsList) return;
      resultsList.innerHTML = '';
      picked.forEach(function (reward) {
        var item = document.createElement('li');
        item.className = 'up-pickcards__result-item';

        var label = document.createElement('span');
        label.className = 'up-pickcards__result-label';
        label.textContent = reward.label;
        item.appendChild(label);

        if (reward.description) {
          var desc = document.createElement('span');
          desc.className = 'up-pickcards__result-desc';
          desc.textContent = reward.description;
          item.appendChild(desc);
        }

        resultsList.appendChild(item);
      });
      if (resultsPanel) resultsPanel.hidden = false;
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        pickCard(card);
      });
    });

    function handleCta() {
      var variantItems = picked
        .filter(function (reward) {
          return reward.variantId;
        })
        .map(function (reward) {
          return { id: parseInt(reward.variantId, 10), quantity: 1 };
        })
        .filter(function (item) {
          return item.id && !isNaN(item.id);
        });

      var code = null;
      for (var i = 0; i < picked.length; i++) {
        if (picked[i].code) {
          code = picked[i].code;
          break;
        }
      }

      var target = config.ctaLink || '/';

      function redirect() {
        close();
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
        } else {
          window.location.href = target;
        }
      }

      if (variantItems.length) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: variantItems })
        }).then(redirect, redirect);
      } else {
        redirect();
      }
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (event) {
        event.preventDefault();
        handleCta();
      });
    }

    var lastFocused = null;

    function trapFocus(event) {
      if (event.key !== 'Tab') return;
      var focusable = getFocusable(dialog);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
      } else {
        trapFocus(event);
      }
    }

    /* Na PDP se driv otevrely oba popupy najednou: pickcards na z-index 9999
       a scratch pod nim, takze po zavreni prvniho vyskocil hned druhy.
       Sdileny klic v sessionStorage pusti za navstevu jen jeden. Kontroluje se
       az ve chvili otevreni, ne pri planovani, protoze oba bezi na setTimeout. */
    function open() {
      try {
        if (sessionStorage.getItem('up-popup-shown') === '1') return;
        sessionStorage.setItem('up-popup-shown', '1');
      } catch (e) {}
      lastFocused = document.activeElement;
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      setFlag(seenKey);
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.addEventListener('keydown', onKeydown);
      var target = closeBtn || dialog;
      if (target) target.focus();
    }

    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);

      var finishClose = function () {
        root.hidden = true;
        dialog.removeEventListener('transitionend', finishClose);
      };
      dialog.addEventListener('transitionend', finishClose);
      setTimeout(finishClose, 500);

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    root.upPickcardsOpen = open;
    root.upPickcardsClose = close;

    var designMode = !!(window.Shopify && window.Shopify.designMode);
    if (designMode && !config.showInEditor) return;

    if (getFlag(seenKey) || getFlag(playedKey)) return;

    setTimeout(open, delayMs);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-up-pickcards]');
    Array.prototype.forEach.call(roots, initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-up-pickcards]')
      : null;
    if (root) initInstance(root);
  });
})();
